// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.list-trash {
  margin: 12px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid var(--sebrae-white);
  min-height: 60px;
  position: relative;
  padding: 5px 10px;
  border-radius: 8px;
  margin: 5px -10px;
}
.list-trash:last-child {
  border-bottom: 0;
}
.list-trash.restoring {
  background-color: #eceeef;
  opacity: 0.8;
  pointer-events: none;
}
.list-trash .wrapper-loading {
  right: 90px;
}
.list-trash button {
  text-decoration: underline;
  color: var(--sebrae-blue);
}
.list-trash h5 {
  color: #243342;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 23.3px;
}
.list-trash p {
  color: #617385;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}`, "",{"version":3,"sources":["webpack://./src/components/card-trash/index.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,4CAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;AACF;AACE;EACE,gBAAA;AACJ;AAEE;EACE,yBAAA;EACA,YAAA;EACA,oBAAA;AAAJ;AAGE;EACE,WAAA;AADJ;AAIE;EACE,0BAAA;EACA,yBAAA;AAFJ;AAKE;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAHJ;AAKE;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAHJ","sourcesContent":[".list-trash {\n  margin: 12px 0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid var(--sebrae-white);\n  min-height: 60px;\n  position: relative;\n  padding: 5px 10px;\n  border-radius: 8px;\n  margin: 5px -10px;\n\n  &:last-child {\n    border-bottom: 0;\n  }\n\n  &.restoring {\n    background-color: #eceeef;\n    opacity: 0.8;\n    pointer-events: none;\n  }\n\n  .wrapper-loading {\n    right: 90px;\n  }\n\n  button {\n    text-decoration: underline;\n    color: var(--sebrae-blue);\n  }\n\n  h5 {\n    color: #243342;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 23.3px;\n  }\n  p {\n    color: #617385;\n    font-size: 13px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    //padding-bottom: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
